<template>
    <div class="box">
        <Header></Header>
      <!--公司新闻-->
        <section>
            <img style="width: 100%;height: 150px;" :src="banner.path" alt="">
            <div class="nav" style="padding: 0 10px;margin-top: 10px;">
                <p style="border-left: 3px solid #BB1E10;padding-left: 10px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? titleName[0] : titleEng[0]}}</p>
                <div style="border-bottom:1px solid #E7E7E7;padding-bottom:20px;" v-for="(item, index) in listData" :key="index" @click="jump(1, item.id)">
                    <p style="color:#BB1E10;font-size:15px;padding-top:20px;font-weight:bold;">{{item.releaseTime}}</p>
                    <p style="color:#121212;font-size:15px;padding-top:10px;font-weight:bold;text-decoration: none;text-overflow: -o-ellipsis-lastline;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;line-clamp: 1; -webkit-box-orient: vertical;">{{typefaces==1?item.name:item.nameEng}}</p>
                    <p style="color:#585858;font-size:14px;padding-top:10px;text-decoration: none;text-overflow: -o-ellipsis-lastline;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;line-clamp: 2; -webkit-box-orient: vertical;">{{typefaces==1?item.text:item.textEng}}</p>
                </div>
            </div>

            <div class="nav" style="padding: 0 10px;margin-top: -80px;">
              <p style="border-left: 3px solid #BB1E10;padding-left: 10px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? titleName[1] : titleEng[1]}}</p>
              <div style="border-bottom:1px solid #E7E7E7;padding-bottom:20px;" v-for="(item, index) in listMediaData" :key="index" @click="jump(3, item.id)">
                <p style="color:#BB1E10;font-size:15px;padding-top:20px;font-weight:bold;">{{item.releaseTime}}</p>
                <p style="color:#121212;font-size:15px;padding-top:10px;font-weight:bold;text-decoration: none;text-overflow: -o-ellipsis-lastline;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;line-clamp: 1; -webkit-box-orient: vertical;">{{typefaces==1?item.name:item.nameEng}}</p>
                <p style="color:#585858;font-size:14px;padding-top:10px;text-decoration: none;text-overflow: -o-ellipsis-lastline;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;line-clamp: 2; -webkit-box-orient: vertical;">{{typefaces==1?item.text:item.textEng}}</p>
              </div>
            </div>

          <div class="nav" style="padding: 0 10px;margin-top: -80px;">
            <p style="border-left: 3px solid #BB1E10;padding-left: 10px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? titleName[2] : titleEng[2]}}</p>
            <img style="width: 100%;height: auto;margin-top: 20px;" src="../../../img/kw/22.png" alt="">
          </div>

          <Footer :typeFaces="typeFacesNumber" ></Footer>
        </section>
    </div>
</template>

<script>
import axios from 'axios';
import Header from '../Header';
import Footer from '../Footer';

export default {
	name: 'Honorary',
	components: {
		Header,
        Footer
	},
	data () {
		return {
      typefaces: 1,
      typeFacesNumber: 0,
      titleName: ['公司新闻','媒体聚焦','企业刊物'],
      titleEng: ['Company News', 'Media focus', 'House Organ'],
      banner: {},
      listData: [],
      listMediaData: []
		}
	},
  computed: {
    aaa() {
      return this.$root.TYPEFACE;
    }
  },
  watch:{
    aaa(type) {
      this.typefaces = type;
    },
  },

	mounted() {
    this.typefaces = (this.$root.TYPEFACE == undefined ? this.typefaces : this.$root.TYPEFACE);
        this.getData();
        this.getList();
        this.getMediaList();
	},

	methods: {
    fatherMethod(type){
      this.typefaces = type;
      this.typeFacesNumber = type;
    },
        // 获取轮播图
		getData() {
			axios({
				url: this.url + '/content/input/fileList',
				method: 'post',
				data: {
					parentId: 0,
                    type: 12
				},
			}).then( res => {
                this.banner = res.data[0][0];
			});
		},

        // 获取列表
        getList() {
            axios({
				url: this.url + '/content/input/list?parentId=0&type=5&pageSize=10&pageNum=1',
				method: 'GET',
				data: {
				},
			}).then( res => {
                this.listData = res.data.rows;
			});
        },


    // 获取列表
    getMediaList() {
      axios({
        url: this.url + '/content/input/list?parentId=0&type=6&pageSize=10&pageNum=1',
        method: 'GET',
        data: {
        },
      }).then( res => {
        this.listMediaData = res.data.rows;
      });
    },
        // 跳转详情页
        jump(text, id) {
            this.$router.push({path:'/Details', name:'Details', query:{text:text,id:id}});
        }
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}
p, span, ul, li{
    margin: 0;
    padding: 0;
}
.box {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
}

section {
    flex: 1;
    overflow-y: scroll;
}

</style>



// WEBPACK FOOTER //
// src/components/CompanyNews/companyNews.vue